import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WorkElectricalMeasurement } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-project-electrical-measurements',
  templateUrl: './ax-project-electrical-measurements.component.html',
  styleUrls: ['./ax-project-electrical-measurements.component.scss'],
})
export class AxProjectElectricalMeasurementsComponent implements OnInit {
  @Input() electricalMeasurements: WorkElectricalMeasurement[];
  @Output() open: EventEmitter<WorkElectricalMeasurement> = new EventEmitter<WorkElectricalMeasurement>();
  @Input() isInternalView = false;
  public accordionStates: any = {};

  constructor() {
  }

  ngOnInit() {
  }
}
